import { useState, useEffect } from "react";

const useArrowsVisibility = (elementRef, showArrow) => {
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    const updateArrowsVisibility = () => {
        const element = elementRef.current;
        if (element) {
            setShowLeftArrow(element.scrollLeft > 0);
            setShowRightArrow(element.scrollLeft < element.scrollWidth - element.clientWidth);
        }
    };

    const scrollTabs = (direction) => {
        const element = elementRef.current;
        if (element) {
            const childWidth = element.firstChild.clientWidth;
            const scrollAmount = childWidth * 2;
            if (direction === "left") {
                element.scrollBy({ left: -scrollAmount, behavior: "smooth" });
            } else if (direction === "right") {
                element.scrollBy({ left: scrollAmount, behavior: "smooth" });
            }
        }
    };

    useEffect(() => {
        const element = elementRef.current;
        if (element) {
            updateArrowsVisibility();
            element.addEventListener('scroll', updateArrowsVisibility);
        }

        return () => {
            if (element) {
                element.removeEventListener('scroll', updateArrowsVisibility);
            }
        };
    }, [elementRef, updateArrowsVisibility]);

    return { showLeftArrow, showRightArrow, scrollTabs };
};

export default useArrowsVisibility;
